import { getHeaderData } from '@/shared/services/header';
import type { HeaderData } from '@/shared/types/header';
import { useEffect, useState } from 'react';

export const useHeaderData = () => {
  const [headerData, setHeaderData] = useState<HeaderData | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchHeaderData = async () => {
      setIsLoading(true);
      setError(null);

      try {
        const response = await getHeaderData();

        if (response && response.menus) {
          setHeaderData(response);
        } else {
          throw new Error('Failed to fetch header data');
        }
      } catch (err) {
        const errorMessage =
          err instanceof Error ? err.message : 'Failed to fetch header data';
        setError(errorMessage);
      } finally {
        setIsLoading(false);
      }
    };

    fetchHeaderData();
  }, []);

  return {
    headerData,
    isLoading,
    error,
  };
};
